import React from "react";
import "./TermsConditions.css";

const TermsConditions = () => {
  return (
    <div className="termsConditions-page">
      {/* Hero Section */}
      <section className="termsConditions-hero">
        <div className="termsConditions-heroOverlay">
          <h1>Terms & Conditions</h1>
          <p>Please read our terms carefully before using our services.</p>
        </div>
      </section>

      {/* Content */}
      <section className="termsConditions-content">
        <div className="termsConditions-card">
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing or using our website and services, you agree to be bound by these
            Terms & Conditions and our Privacy Policy. If you do not agree, you must stop
            using our services immediately.
          </p>
        </div>

        <div className="termsConditions-card">
          <h2>2. Use of Services</h2>
          <p>
            You agree to use our services only for lawful purposes. Any unauthorized or
            fraudulent use of our platform is strictly prohibited and may lead to legal
            action.
          </p>
        </div>

        <div className="termsConditions-card">
          <h2>3. Booking & Payments</h2>
          <p>
            All bookings are subject to availability and confirmation. Payments must be made
            through approved methods. We are not responsible for issues arising from
            third-party payment gateways.
          </p>
        </div>

        <div className="termsConditions-card">
          <h2>4. Cancellations & Refunds</h2>
          <p>
            Cancellation and refund policies vary depending on the service provider (airlines,
            hotels, buses, etc.). Please review the specific terms before completing your
            booking.
          </p>
        </div>

        <div className="termsConditions-card">
          <h2>5. Limitation of Liability</h2>
          <p>
            We act as an intermediary between you and service providers. We are not liable
            for delays, cancellations, or losses caused by third-party providers.
          </p>
        </div>

        <div className="termsConditions-card">
          <h2>6. Intellectual Property</h2>
          <p>
            All content, design, and branding on this website are our intellectual property
            and may not be copied, modified, or distributed without prior written consent.
          </p>
        </div>

        <div className="termsConditions-card">
          <h2>7. Governing Law</h2>
          <p>
            These Terms & Conditions shall be governed by and construed in accordance with the
            laws of India. Any disputes will be subject to the jurisdiction of courts in
            Delhi, India.
          </p>
        </div>

        <div className="termsConditions-card">
          <h2>8. Changes to Terms</h2>
          <p>
            We reserve the right to update these Terms & Conditions at any time. Any changes
            will be effective immediately upon posting on this page.
          </p>
        </div>
      </section>
    </div>
  );
};

export default TermsConditions;
